import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToolsService} from '../../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class GameLevelCultureService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {
  }

  findAllByLevel(idLevel: string) {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}cultures/level/${idLevel}`).toPromise();
  }
}
